'use client'

import { useEffect, useState } from 'react'

import { formatHeroCounterValue } from '@/utils/formatHeroCounterValue'
import {
	getHeroCounterValue,
	HERO_COUNTER_MULTIPLIER,
} from '@/utils/getHeroCounterValue'

type Props = {
	id: string
	initialValue: number
	locale: string
}

export const HeroCounterValue = ({ id, initialValue, locale }: Props) => {
	// On the server (and as a client-only fallback) this is just the SSR
	// value. HeroCounterLiveScript already overwrote this node's DOM text
	// with a live value before any JS framework loaded, so during hydration
	// we read that back instead of recomputing — React's expected output
	// then matches the DOM exactly, so there's nothing to reconcile or
	// revert, no matter how hydration handles a real mismatch.
	const [text, setText] = useState(() =>
		typeof document === 'undefined'
			? formatHeroCounterValue(initialValue, locale)
			: (document.getElementById(id)?.textContent ??
				formatHeroCounterValue(initialValue, locale)),
	)

	useEffect(() => {
		const handlePageShow = () => {
			setText(
				formatHeroCounterValue(
					getHeroCounterValue(HERO_COUNTER_MULTIPLIER),
					locale,
				),
			)
		}
        handlePageShow()
		window.addEventListener('pageshow', handlePageShow)

		return () => window.removeEventListener('pageshow', handlePageShow)
	}, [locale])

	return (
		<span
			id={id}
			className="inline-block text-center font-semibold"
		>
			{text}
		</span>
	)
}
